/*
 * REMOVE FROM PIPELINE…, FROM A FOLLOW-UPS ROW.
 *
 * "I've chased enough, take them off my pipeline, bring them back only if they
 * write." Snooze is not that (After their next reply has a 42-day backstop), and
 * Ignore is a queue mute that leaves the company on the board. The record already
 * has the ending that is: Remove from pipeline… (record/endings.mjs, confirm
 * "remove"), so the row's Ignore menu opens that same confirm (ConfirmCard) with
 * the same reasons, reminder and note, and ConfirmCard sends the same writes.
 *
 * Two things are the row's own, and they are here so they can be tested:
 *
 *   canRemove     offered exactly where the record's Change status… offers it
 *                 (a prospect or a lost company), read off that same menu rather
 *                 than a second copy of its gate.
 *   withRowWrites the writes ConfirmCard hands to ops.runWrites, plus one for a
 *                 row pinned under "Scheduled for today": that section is a snooze
 *                 come due, which a park does not clear, so without it the row
 *                 would stay pinned after the company left the board. Removing it
 *                 answers that promise.
 *
 * Pure.
 */
import { changeStatusOptions, offeredIds } from "./record/endings.mjs";

export function canRemove(row) {
  if (!row || !row.company_id) return false;
  const company = { id: row.company_id, status: row.status, pipeline_stage: row.pipeline_stage };
  return offeredIds(changeStatusOptions({ company })).includes("remove");
}

export function withRowWrites(writes, { companyId, section = null }) {
  const out = [...(writes || [])];
  if (section === "scheduled" && companyId) {
    out.push({ method: "POST", path: `/follow-ups/${companyId}/unmute`, body: { what: "snooze" } });
  }
  return out;
}
